<template>
  <zj-layout-container>
    <zj-layout-header>
      <el-form
        class="zj-search-form"
        ref="form"
        :model="form"
        :label-width="labelWidth"
      >
        <el-form-item label="出现时间">
          <el-date-picker
            v-model="date"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 60rem"
            unlink-panels
            value-format="yyyy-MM-dd HH:mm:ss"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main v-loading="loading" :element-loading-text="loadingText">
      <div class="zj-layout-main-content bgcolor scrollable">
        <div style="width: 100%; height: auto">
          <div v-for="avatar in avatars" :key="avatar" class="avatar">
            <div @dblclick="ondbClickAv(avatar)">
              <el-avatar
                shape="square"
                :size="120"
                fit="fill"
                :src="
                  `https://docking.xjtstc.com/preview?file_id=${avatar.snapUrl}`
                "
              ></el-avatar>
              <div style="padding: 0.5rem">{{ avatar.cameraName }}</div>
              <div style="padding: 0.5rem">{{ avatar.dataTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
    <div>
      <el-dialog :visible.sync="dialogVisible">
        <div style="padding: 1rem">
          <el-form :model="selectedavatar">
            <el-image
              shape="square"
              fit="fill"
              :src="
                `https://docking.xjtstc.com/preview?file_id=${selectedavatar.snapUrl}`
              "
              style="width: 100%"
            ></el-image>
            <el-form-item label style="padding-top: 3rem" class="center">
              <!-- <el-button @click="onControlAvatar(selectedavatar)"
                >布 控</el-button
              > -->
              <el-button
                @click="onSearchAvatar(selectedavatar)"
                style="margin-left: 5rem"
                >搜 索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </zj-layout-container>
</template>
<script>
import { facePage } from "../../../../../../request/api";

export default {
  name: "FaceList",
  controller: "UI",
  action: "FaceList",
  data() {
    return {
      date: [new Date(new Date().setHours(0, 0, 0, 0)),new Date(new Date().setHours(23, 59, 59, 59))],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      IndexCode: "",
      DeviceName: "",
      avatars: [],
      dialogVisible: false,
      selectedavatar: {},
      loading: false,
      loadingText: "加载中...",
    };
  },
  created(){
  },
  mounted() {
    //人脸接口
    //TODO 根据设备id查询
    this.search();
  },
  methods: {
    refreshImage(data) {
      this.IndexCode = data.id;
      this.DeviceName = data.label;
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    search() {
      this.loading = true;
      let _this = this;
      let params={
        baseUrl:global.$config.api.docking_url,
        data:{
          page: _this.currentPage,
          size: _this.pageSize,
          startTime: _this.date[0],
          endTime: _this.date[1],
          cameraCode: this.IndexCode,
       }
      }
      facePage(params)
        .then((res) => {
          // console.log("人脸结果")
          // console.log(res)
          this.loading = false;
          if (res.code == 0) {
            _this.avatars = res.data;
            _this.total = res.count;
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    ondbClickAv(avatar) {
      this.dialogVisible = true;
      this.selectedavatar = avatar;
    },
    //搜索
    onSearchAvatar(avatar) {
      // avatar.url = avatar.snapUrl
      this.$router.push({
        path: "/plugin/Face/UI/FaceAuatarList",
        query: { avatarobj: avatar, date: new Date() },
      });
    },
    onCancel() {
      this.date = [new Date(), new Date()];
      this.search();
    },
    //布控
    onControlAvatar(avatar) {
      this.$router.push({
        path: "/plugin/Face/UI/FaceAddControl",
        query: { url: avatar.url, date: new Date() },
      });
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
<style>
.avatar {
  display: block;
  float: left;
  padding: 1.5rem;
}
</style>
